import api from '../api';
// import router from '../router';

export default {
    namespaced: true,
    state: {
        threads: null,
        thread: null
    },
    mutations: {
        threads(state, value) {
            state.threads = value;
        },
        thread(state, value) {
            state.thread = value;
        }
    },
    getters: {
        //
    },
    actions: {
        clearThread({ commit }) {
            return new Promise((resolve) => {
                commit('thread', null);
                resolve();
            });
        },
        clearThreads({ commit }) {
            return new Promise((resolve) => {
                commit('threads', null);
                resolve();
            });
        },
        getThreads({ commit }, page) {
            const pageQuery = page ? `?page=${page}` : '';
            return api.get(`messages${pageQuery}`)
                .then((response) => {
                    commit('threads', response.data.payload.threads);
                })
                .catch(() => {

                });
        },
        getThread({ commit }, threadId) {
            return api.get(`messages/${threadId}`)
                .then((response) => {
                    commit('thread', response.data.payload);
                })
                .catch(() => {

                });
        },
        createThread({ commit }, data) {
            return api.post('messages', data);
        },
        addMessage({ commit }, data) {
            return api.post(`messages/${data.threadId}`, data)
                .then((response) => {
                    //
                })
                .catch((response) => {
                    //
                });
        }
    }
};
